function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.8 0H2.2C1.3 0 .5.7.5 1.7v3.1c0 .9.7 1.7 1.7 1.7s1.7-.7 1.7-1.7V3.3h5.5v17.4H7c-.9 0-1.7.7-1.7 1.7 0 .9.8 1.6 1.7 1.6h7.7c.9 0 1.7-.7 1.7-1.7 0-.9-.7-1.7-1.7-1.7h-2V3.3h5.5v1.4c0 .9.7 1.7 1.7 1.7.9 0 1.7-.7 1.7-1.7v-3c-.1-1-.9-1.7-1.8-1.7z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24"
  }, props), _ref);
};

export default SvgComponent;